import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-description-section gfu-project-description-section--emphasized" }
const _hoisted_2 = {
  class: "_tc--gray gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
  "data-qa": "project-description-section:Adfound banner"
}
const _hoisted_3 = ["href", "title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: $options.performanceMarketingUrlWithRef,
        target: "_blank",
        rel: "noopener noreferrer",
        title: _ctx.Resources.ProjectHome.PerformanceMarketingBannerLabel
      }, [
        _createVNode(_component_base_image, { src: $options.imgUrl }, null, 8 /* PROPS */, ["src"])
      ], 8 /* PROPS */, _hoisted_3)
    ])
  ]))
}